module.exports = __webpack_public_path__ + "static/img/eqlogo.656e501.png";


//////////////////
// WEBPACK FOOTER
// ./src/eqvideoAdmin/imgs/eqlogo.png
// module id = VYF+
// module chunks = 1